// 
import axios from 'axios';
import * as endpoints from './const';

class AccountApi {

  /**
   * user has accepted terms and conditions
   */
  static acceptTerms() {
    return axios.post(endpoints.ACCEPT_TERMS)
      .then(response => response.data)
      .catch((error) => { throw(error); });
  }

}

export default AccountApi;



// WEBPACK FOOTER //
// ./src/api/AccountApi.js